import { forwardRef, createElement } from 'react';

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _ref2 = /*#__PURE__*/createElement("path", {
  d: "M22.991 3.95a1 1 0 00-1.51-.86 7.48 7.48 0 01-1.873.794 5.153 5.153 0 00-3.374-1.242 5.232 5.232 0 00-5.224 5.063 11.032 11.032 0 01-6.814-3.924 1.011 1.011 0 00-.857-.365.998.998 0 00-.785.5 5.275 5.275 0 00-.242 4.769l-.002.002a1.041 1.041 0 00-.495.888c-.002.147.007.294.026.44a5.185 5.185 0 001.568 3.312.999.999 0 00-.066.77 5.204 5.204 0 002.362 2.921 7.465 7.465 0 01-3.59.449A1 1 0 001.45 19.3a12.942 12.942 0 007.01 2.061 12.788 12.788 0 0012.465-9.363c.353-1.183.533-2.412.535-3.646v-.2A5.77 5.77 0 0022.99 3.95zm-3.306 3.212a.995.995 0 00-.234.702c.01.165.01.331.01.488a10.825 10.825 0 01-.455 3.08 10.684 10.684 0 01-10.546 7.93c-.859 0-1.715-.101-2.55-.301a9.48 9.48 0 002.942-1.564 1.001 1.001 0 00-.602-1.786 3.208 3.208 0 01-2.214-.935c.15-.028.298-.063.446-.105a1 1 0 00-.08-1.944 3.197 3.197 0 01-2.25-1.725c.18.025.362.04.544.046a1.022 1.022 0 00.984-.696 1 1 0 00-.4-1.137 3.196 3.196 0 01-1.418-2.871 13.014 13.014 0 008.208 3.48 1.02 1.02 0 00.818-.36 1 1 0 00.206-.867 3.159 3.159 0 01-.087-.729 3.23 3.23 0 014.506-2.962c.403.176.766.433 1.065.756a.993.993 0 00.921.298 9.27 9.27 0 001.212-.322 6.679 6.679 0 01-1.026 1.524z",
  fill: "currentColor"
});

function SvgTwitterAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/forwardRef(SvgTwitterAlt);

export { ForwardRef as ReactComponent };
//# sourceMappingURL=twitter-alt.svg.js.map
